import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './Image.module.sass';

const Image = ({ src, alt = '', getDimensions = () => {}, onLoad, onError, onClick, classes, useDefaultClass = true, noTouchAction = true }) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);
  const ref = useRef();

  useEffect(() => {
    if (!loaded) return;

    if (onLoad) onLoad();
    getDimensions(ref.current);
  }, [loaded]);

  useEffect(() => {
    if (!error) return;

    if (onError) onError();
  }, [error]);

  if (!src || error) return null;

  const touchStyle = noTouchAction ? {} : {}

  return (
    <img
      ref={ref}
      style={touchStyle}
      draggable="false"
      src={src}
      alt={alt}
      onClick={onClick}
      onLoad={() => setLoaded(true)}
      onError={() => setError(true)}
      className={cn(useDefaultClass && styles.img, classes)}
    />
  );
}

Image.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  classes: PropTypes.string,
};

export default Image;
